import facebook_post from './facebook-post';
import facebook_story from './facebook-story';

export default {
    facebook_post,
    facebook_story
}